<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Admin Contact
    </div>
    <div class="enterprise-network_container_table">
      <el-row class="enterprise-network_mb-40">
        <el-col :span="12">
          <div class="enterprise-network_label">Name</div>
          <div class="enterprise-network_value">
            {{ formData.generalManagerName || "-" }}
          </div>
        </el-col>
        <el-col :span="12">
          <div class="enterprise-network_label">Work Email</div>
          <div class="enterprise-network_value">{{ formData.email || "-" }}</div>
        </el-col>
      </el-row>
      <el-row class="enterprise-network_mb-40" v-if="!isEdit">
        <el-col :span="12">
          <div class="enterprise-network_label">Job Title</div>
          <div class="enterprise-network_value">{{ formData.position || "-" }}</div>
        </el-col>
        <el-col :span="12">
          <div class="enterprise-network_label">Office Phone</div>
          <div class="enterprise-network_value">{{ formData.officePhone || "-" }}</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "enterpriseNetworkMainContact",
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    getFormData() {
      let isPass = true;
      if (isPass) {
        let formData = JSON.parse(JSON.stringify(this.formData));
        formData.generalManagerName =
          formData.firstName + " " + formData.lastName;
        if (formData.countryCode && formData.telephone) {
          if (formData.stateNumber && formData.extension) {
            formData.officePhone = `+${formData.countryCode} (${formData.stateNumber}) ${formData.telephone} ext.${formData.extension}`;
          } else if (formData.stateNumber) {
            formData.officePhone = `+${formData.countryCode} (${formData.stateNumber}) ${formData.telephone}`;
          } else if (formData.extension) {
            formData.officePhone = `+${formData.countryCode} ${formData.telephone} ext.${formData.extension}`;
          } else {
            formData.officePhone = `+${formData.countryCode} ${formData.telephone}`;
          }
        }
        return formData;
      } else {
        return isPass;
      }
    },
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/channelAgreement/twentyTwentyFive/EBG/components/mainContact/mainContactDetail.vue